import { message, Modal } from 'antd';
import React from 'react';
import fa from 'locales/fa.json';
import { useForm } from 'react-hook-form';
import AntButton from 'components/Common/AntButton';
import FormInput from 'components/Common/FormInput';
import request from 'services/request';
import { ChangePasswordUrl } from 'services/routes';

type ChangeType = { visible: boolean; setVisible: (statues) => void };
const ChangePassword: React.FC<ChangeType> = ({ visible, setVisible }) => {
  const { handleSubmit, watch, formState, control, reset } = useForm();
  const onSubmit = async (data): Promise<void> => {
    const res: any = await request.post(ChangePasswordUrl(), data); // eslint-disable-line
    if (res.ok) {
      message.success(res.data.message);
      setVisible(false);
      reset();
    }
  };

  return (
    <Modal
      title={null}
      footer={null}
      width={600}
      destroyOnClose
      visible={visible}
      onCancel={(): void => (setVisible(false), reset())}
    >
      <div className="center flex-col">
        <h2 className="text-[18px] font-bold mb-[36px]">{fa.account.changePassword}</h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormInput
            control={control}
            name="old_password"
            type="password"
            className="mb-16 w-[250px] md:w-[300px]"
            rules={{ required: true, minLength: 8 }}
            title={fa.account.currentPassword}
          />
          <FormInput
            control={control}
            name="password"
            type="password"
            className="mb-16 w-[250px] md:w-[300px]"
            rules={{ required: true, minLength: 8 }}
            title={fa.account.newPassword}
          />
          <FormInput
            control={control}
            name="password_confirmation"
            type="password"
            className="mb-16 w-[250px] md:w-[300px]"
            rules={{
              required: true,
              minLength: 8,
              // eslint-disable-next-line consistent-return
              validate: (val: string): string => {
                if (watch('password') !== val) {
                  return fa.account.notMatch;
                }
              },
            }}
            title={fa.account.repeatNewPassword}
          />

          <AntButton
            htmlType="submit"
            className="w-full mb-8"
            loading={formState.isSubmitting}
          >
            {fa.account.changePassword}
          </AntButton>
        </form>
      </div>
    </Modal>
  );
};

export default ChangePassword;
